import React from 'react';
import { makeStyles } from '@mui/styles';
import WebLink from '../@common/WebLink';
import { translate } from '../../translations/translator';
import drawnCirclePath from 'assets/images/gray-drawn-circle.png';
import { remCalc } from '../../util/style-util';
import { darkestGray } from '../../styles/style-constants';
import { useSelector } from 'react-redux';
import { AppStoreState } from 'types';
import { useTheme } from '@mui/material';
const translateFooter = key => translate('footer', key);

function TrialBadge({ daysLeft, showTrialModal }) {
  const disableTrialModal = showTrialModal === null;
  const user = useSelector(({ user }: AppStoreState) => user);
  const theme = useTheme();
  const { trialReminder, trialBadge, dayCount, trialLink } = useStyles(theme)(disableTrialModal);

  if (user.isAuditor || !daysLeft) return <></>;

  return (
    <div className={trialReminder}>
      <div className={trialBadge}>
        <span className={dayCount}>{daysLeft}</span>
      </div>
      {disableTrialModal ? (
        <span className={trialLink}>{translateFooter('trialDaysLeft')}</span>
      ) : (
        <WebLink
          to="#"
          onClick={showTrialModal}
          className={trialLink}
          name={translateFooter('trialDaysLeft')}
        />
      )}
    </div>
  );
}

const useStyles = theme =>
  makeStyles(() => ({
    trialReminder: {
      marginLeft: remCalc(10),
      marginTop: remCalc(-10)
    },
    trialBadge: {
      height: remCalc(35),
      width: remCalc(35),
      padding: remCalc(6, 0, 0, 8),
      backgroundImage: `url('${drawnCirclePath}')`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      display: 'inline-block',
      textAlign: 'left'
    },
    dayCount: {
      display: 'inline-block',
      width: remCalc(21),
      textAlign: 'center',
      color: darkestGray,
      padding: '5px 0 0 2px'
    },
    trialLink: disableTrialModal => ({
      textDecoration: disableTrialModal ? '' : 'underline',
      color: theme.palette.primary.contrastText,
      marginLeft: remCalc(10),
      marginTop: remCalc(-5),
      '&:hover': {
        color: theme.palette.primary.contrastText
      },
      '&:active': {
        color: theme.palette.primary.contrastText
      }
    })
  }));

export default TrialBadge;
